// extracted by mini-css-extract-plugin
export default {"titleContainer":"notification-scroll-list_titleContainer__9Sdtg global_cnHeader4Bold__rEi5c","listContainer":"notification-scroll-list_listContainer__t0Qhe"};